import { render, staticRenderFns } from "./generic_bar_goals_chart.vue?vue&type=template&id=611ec4c9&"
import script from "./generic_bar_goals_chart.vue?vue&type=script&lang=js&"
export * from "./generic_bar_goals_chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports